/**
 * Convert a numeric value to CSS length unit
 * @param {string|number} length A number or string
 * @param {string} [unit=px] The length unit to use
 * @returns {string} CSS length expression
 */
const convertCssNumberToString = (length, unit = 'px') => typeof length === 'number' ? `${length}${unit}` : length;

export { convertCssNumberToString };
//# sourceMappingURL=convertCssNumberToString.js.map
